module.exports = __webpack_public_path__ + "img/collapse.821355fb.svg";